<script setup>
  import { ref, onMounted } from 'vue';
  import { useMapStore } from "@/stores/MapStore";
  import { useStormStore } from "@/stores/StormStore";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import useLegacyBridge from "@/composables/useLegacyBridge";
  import useSettingsGlobals from '@/composables/useSettingsGlobals';
  import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();  
  const { $DETAIL_PANEL } = useMapConfigurationGlobals();  

  const mapReady = defineModel('mapReady');

  const props = defineProps({
    region: {
      type: String,
      default: null
    }
  });

  const mapStore = useMapStore();
  const stormStore = useStormStore();

  const isDesktop = useMediaQuery('(min-width: 840px)');
  const { cosmos } = useLegacyBridge();

  const cosmosUI = ref(null);

  const uiOptions = {
      useJwxUI: true,
      tempestMeta: true,
      excludedOverlays: [],
      viewId: "8",
      miniGraphOptions: {
          showModelData: false,
          extents: [-4, 4],
      },
      uiElements: [
          jweather.UIElements.LEGEND,
          jweather.UIElements.QUICKVIEW,
          jweather.UIElements.ZOOM_CONTROLS,
          jweather.UIElements.DETAIL_BUTTON
      ],
      rightPanel: {
          excludedTabs: [],
          containerSettings: {
              "current-conditions": {
                  showDataFieldsMenu: true,
                  showNearbySpots: true,
                  showVirtual: false
              },
              "station-info": {
                  showFullMetadata: true
              }
          }
      },
      regionalProducts: {
          products: jweather.RegionalProducts.ALLOWED_PRODUCTS,
          productSettings: jweather.RegionalProducts.DEFAULT_PRODUCT_SETTINGS
      },
      infoWindowType: $WEB_VIEW ? "web_view" : "default"
    };

    if ($DETAIL_PANEL && isDesktop.value && !$WEB_VIEW) {
      uiOptions.uiElements.push(jweather.UIElements.DETAIL_PANEL);
    }
  
    const mapOptions = {
      "searchType": "search",
      "zoom": 5,
      "width": "100%",
      "height": "100%",
      "lat": 40.86,
      "lon": -83.975,
      "enableArbitraryMarkers": true
    };       

    function loadCosmos() {
      const mapContainer = document.querySelector('[data-map="map"]');
      cosmosUI.value = cosmos(mapContainer, uiOptions, mapOptions)
    }

    function loadCompleteReport(spot) {
      if (import.meta.env.DEV) {
        console.log(`/spot/${spot[0]}`);
        return;
      }
      
      window.location = `/spot/${spot[0]}`;
    }

    onMounted(() => {
      loadCosmos();

      window.$EventBus.addEventListener('map-ready', (e) => {
        window.$JWX.map = e.detail.map;
        window.$JWX.cosmos = e.detail.cosmos;

        if (props.region) {
          window.$JWX.map.setBounds(stormStore.stormRegionBounds[props.region] || stormStore.stormRegionBounds['default']);
        }

        google.maps.event.addListener(window.$JWX.map, 'idle', function () {
          mapReady.value = true;
          mapStore.loadInitialView();
        });

        if (!$WEB_VIEW) {
          google.maps.event.addListener(cosmosUI.value, "detail_clicked", loadCompleteReport);
        }
        
      });
    });
</script>

<template></template>